import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const bancaAcoesAfirmativasRoutes: Routes = [
  {
    path: 'banca-de-acoes-afirmativas',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./banca-acoes-afirmativas.component').then(m => m.BancaAcoesAfirmativasComponent),
        data: {
          title: 'Banca de Ações Afirmativas',
          roles: [Role.AVALIACAO_FENOTIPICA_VISUALIZAR, Role.ANALISE_DOCUMENTAL_ACOES_AFIRMATIVAS_LISTAR, Role.BANCA_ACOES_AFIRMATIVAS_CONSULTAR],
          breadcrumb: [{label: 'Banca de Ações Afirmativas', url: '/banca-de-acoes-afirmativas'}],
        },
      },
    ],
  },
  {
    path: 'banca-acoes-afirmativas',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Banca de Ações Afirmativas',
      breadcrumb: [{ label: 'Banca de Ações Afirmativas', url: '/banca-de-acoes-afirmativas' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./banca-acoes-afirmativas-list/banca-acoes-afirmativas-list.component').then(
            (m) => m.BancaAcoesAfirmativasListComponent,
          ),
        data: {
          title: 'Listagem de Profissionais',
          roles: [Role.BANCA_ACOES_AFIRMATIVAS_CONSULTAR],
          breadcrumb: [
            { label: 'Banca de Ações Afirmativas', url: '/banca-de-acoes-afirmativas' },
            { label: 'Listagem de Profissionais', url: '/banca-acoes-afirmativas' },
          ],
        },
      },
      {
        path: ':inscricaoCicloId',
        loadComponent: () =>
          import('./banca-acoes-afirmativas-detail/banca-acoes-afirmativas-detail.component').then(
            (m) => m.BancaAcoesAfirmativasDetailComponent,
          ),
        data: {
          title: 'Informações Documentais',
          roles: [Role.BANCA_ACOES_AFIRMATIVAS_CONSULTAR],
          breadcrumb: [
            { label: 'Banca de Ações Afirmativas', url: '/banca-de-acoes-afirmativas' },
            { label: 'Listagem de Profissionais', url: '/banca-acoes-afirmativas' },
            { label: 'Informações Documentais' },
          ],
        },
      },
    ],
  },
];
